import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import LoginScreen from './components/LoginScreen';
import AuthCallback from './components/AuthCallback';
import AppMain from './components/AppMain';
import './App.css';

const App: React.FC = () => {
  return (
    <Router>
      <div className="App">
        <Routes>
          {/* Login route */}
          <Route path="/" element={<LoginScreen />} />
          <Route path="/login" element={<LoginScreen />} />
          
          {/* OAuth callback route */}
          <Route path="/auth-callback" element={<AuthCallback />} />
          
          {/* App routes - require authentication */}
          <Route path="/app" element={<AppMain />} />
          
          {/* Catch all - redirect to login */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </div>
    </Router>
  );
};

export default App;

